import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { billingExplorerWidgetCostsSelector } from "./billingExplorerWidgetCostsSelector";

export const billingExplorerWidgetPrevTotalCostSelector =
  createDraftSafeSelector([billingExplorerWidgetCostsSelector], (costs) => {
    return costs?.previousPeriodTotal;
  });
